import Stack from "@mui/material/Stack";

export const Page404 = () => {
  return (
    <Stack
      component="main"
      spacing={{ xs: 4 }}
      sx={{
        marginTop: 4,
        marginBottom: 12,
      }}
    >
      404
    </Stack>
  );
};
